import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { AcceptIcon, CancelIcon, ErrorIcon, InfoIcon, StarIcon, WarningIcon } from "tombac-icons";
import { tombac } from "../../shared";
import { propStyling } from "../../shared/propStyling";
import { Box } from "../Styling/Box";
import { Label, Text } from "../Typography";
const AlertContainer = styled.div.withConfig({
  displayName: "Alert__AlertContainer"
})(["box-sizing:border-box;opacity:1;display:block;", " ", ";"], _ref => {
  let {
    isOpen,
    animationState
  } = _ref;
  return css(["opacity:", ";max-height:", ";transition:all 0.2s;transition-timing-function:ease-out;display:", ";"], () => isOpen ? "1" : "0", () => isOpen ? "100%" : "0", () => !isOpen && animationState === "exited" ? "none" : "block");
}, propStyling);
const DismissButton = styled.div.withConfig({
  displayName: "Alert__DismissButton"
})(["align-self:stretch;background:none;font-size:inherit;height:auto;padding:0;width:", ";"], tombac.space(6));
const AlertToolbar = styled.div.withConfig({
  displayName: "Alert__AlertToolbar"
})(["white-space:nowrap;margin-left:auto;"]);
const AlertLayout = styled.div.withConfig({
  displayName: "Alert__AlertLayout"
})(["all:initial;display:flex;position:relative;padding:", ";", ";", "{margin:", ";display:flex;align-items:center;justify-content:center;cursor:pointer;", ";&:hover{background:", ";}}"], tombac.space(2, 0), _ref2 => {
  let {
    alertColor
  } = _ref2;
  return css(["background-color:", ";border:", " solid ", ";"], tombac.color(alertColor, 100), tombac.unit(1), tombac.color(alertColor, 500));
}, DismissButton, tombac.space(-2, 0), _ref3 => {
  let {
    alertColor
  } = _ref3;
  return css(["border-left:", " solid ", ";color:", ";"], tombac.unit(1), tombac.color(alertColor, 500), tombac.color(alertColor, 500));
}, _ref4 => {
  let {
    alertColor
  } = _ref4;
  return tombac.color(alertColor, 200);
});
const AlertIcon = styled.div.withConfig({
  displayName: "Alert__AlertIcon"
})(["all:initial;display:block;padding-left:", ";margin-right:", ";", ""], tombac.space(1), tombac.space(-1), _ref5 => {
  let {
    $color
  } = _ref5;
  return $color === "neutral" ? css(["color:", ";"], tombac.color($color, 900)) : css(["color:", ";"], tombac.color($color));
});
const alertTypeIconMap = {
  alert: WarningIcon,
  danger: ErrorIcon,
  default: StarIcon,
  info: InfoIcon,
  success: AcceptIcon
};
const alertTypeColorMap = {
  success: "success",
  alert: "alert",
  danger: "danger",
  info: "accent",
  default: "neutral"
};
export const Alert = _ref6 => {
  let {
    title,
    variant,
    children,
    toolbar,
    icon,
    onRequestClose,
    isOpen = true,
    ...stylingProps
  } = _ref6;
  const [animationState, setAnimationState] = useState("exited");
  const Icon = alertTypeIconMap[variant];
  const color = alertTypeColorMap[variant];
  const handleTransitionEnd = event => {
    const {
      propertyName
    } = event;
    setAnimationState(state => {
      if (state === "exiting" && propertyName === "opacity") {
        return "exited";
      }
      return state;
    });
  };
  const onClose = () => {
    setAnimationState("exiting");
    if (onRequestClose) {
      onRequestClose();
    }
  };
  return /*#__PURE__*/React.createElement(AlertContainer, _extends({}, stylingProps, {
    isOpen: isOpen,
    onTransitionEnd: handleTransitionEnd,
    animationState: animationState
  }), /*#__PURE__*/React.createElement(AlertLayout, {
    alertColor: color
  }, /*#__PURE__*/React.createElement(AlertIcon, {
    $color: color
  }, typeof icon === "undefined" ? /*#__PURE__*/React.createElement(Icon, {
    size: "lg"
  }) : icon), /*#__PURE__*/React.createElement(Box, {
    $display: "flex",
    $flexDirection: toolbar ? "row" : "column",
    $alignItems: toolbar ? "center" : "baseline",
    $pl: "2sp",
    $pr: "2sp",
    $mt: "3u",
    $width: "100%",
    $alignSelf: "center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    as: "div",
    fontSize: 12
  }, title), /*#__PURE__*/React.createElement(Text, {
    as: "div"
  }, children)), toolbar && /*#__PURE__*/React.createElement(AlertToolbar, null, toolbar)), onRequestClose && /*#__PURE__*/React.createElement(DismissButton, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CancelIcon, null))));
};
//# sourceMappingURL=Alert.js.map